export default "__VITE_ASSET__dbb3d16f__"